import { RiSearch2Line } from "react-icons/ri";
import { CardComp, ButtonComp, TableCompData } from "../../../components";
import EmptyTable from "../../../components/Common/EmptyTable";
import TablePagination from "../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";

const StaffMemberTable = ({
  tableData = [],
  tableColumns,
  title,
  tableFor = "member",
  isFetchingData = false,
  addNew,
  pagination,
  onSearch = () => {},
  onPageChange = () => {},
  onDownloadCSV = null,
  onDownloadPDF = null,
  isDownloadingCSV = false,
  isDownloadingPDF = false,
  searchTerm = "",
  pageNumber = 1,
}) => {
  return (
    <section className="px-3 px-lg-5 min-vh-100 pb-5 mb-5">
      <CardComp cardClassName={"border-0 mb-4 shadow-sm"}>
        <div className="px-3 px-lg-4 py-3" data-tour={tableFor === "members" ? "staff-members-header" : undefined}>
          <div className="row justify-content-between align-items-center flex-wrap g-3">
            <div className="col-12 col-lg-6">
              <h3
                className="text-dark fw-bold mb-0"
                style={{ fontSize: "24px" }}
              >
                {title || "Staff list"}
              </h3>
            </div>
            <div className="col-12 col-lg-6" data-tour={tableFor === "members" ? "staff-members-search" : undefined}>
              <div
                className="input-group search"
                style={{ borderRadius: "30px", overflow: "hidden" }}
              >
                <span
                  className="input-group-text border-0"
                  style={{
                    cursor: "pointer",
                    backgroundColor: "var(--color-primary-dark)",
                    padding: "12px 15px 12px 20px",
                  }}
                >
                  <RiSearch2Line size={18} color={"#fff"} />
                </span>
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Search by name, email, phone, or membership number..."
                  style={{
                    padding: "12px 15px 12px 10px",
                    fontSize: "14px",
                    backgroundColor: "#fafafa",
                    borderRadius: "0 30px 30px 0",
                    border: "none",
                  }}
                  value={searchTerm}
                  onChange={(event) => onSearch(event.target.value)}
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      onSearch(event.target.value);
                    }
                  }}
                  onFocus={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.border = "1px solid var(--color-primary)";
                  }}
                  onBlur={(e) => {
                    e.target.style.backgroundColor = "#fafafa";
                    e.target.style.border = "none";
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </CardComp>
      <CardComp
        cardClassName={"border-0 shadow-sm"}
        {...(tableFor === "members"
          ? { "data-tour": "staff-members-table" }
          : {})}
      >
        <div className="px-3 px-lg-4 py-0">
          <TableCompData
            marginBottom={"120px"}
            columns={tableColumns}
            data={tableData}
            progressPending={isFetchingData}
            progressComponent={<TableSkeletonLoader rows={10} columns={6} />}
            message={
              !isFetchingData && (
                <EmptyTable
                  Message={
                    tableFor === "members" &&
                    title?.toLowerCase().includes("archived")
                      ? `You have no archived ${tableFor} list`
                      : `You have no active ${tableFor} list, please create`
                  }
                  btnText={
                    tableFor === "members" &&
                    title?.toLowerCase().includes("archived")
                      ? undefined
                      : `Add new ${tableFor}`
                  }
                  onClick={
                    tableFor === "members" &&
                    title?.toLowerCase().includes("archived")
                      ? undefined
                      : addNew
                  }
                />
              )
            }
          />
        </div>
      </CardComp>
      {tableData.length > 0 && (
        <>
          <div className="py-3"></div>
          <CardComp cardClassName={"border-0 shadow-sm"}>
            <div className="px-3 px-lg-4 py-3">
              <h5
                className="text-dark fw-bold mb-3"
                style={{ fontSize: "18px" }}
              >
                Need{" "}
                {tableFor === "member" || tableFor === "members"
                  ? "member"
                  : "staff"}{" "}
                records?
              </h5>
              <div className="d-flex gap-3 align-items-center flex-wrap">
                <ButtonComp
                  btnText={isDownloadingCSV ? "Downloading..." : "Download CSV"}
                  btnClassName={`py-2 px-4 px-lg-5 fw-semibold bg-primary1 border-0 text-white rounded ${
                    isDownloadingCSV ? "opacity-75" : ""
                  }`}
                  containerClassName="w-auto"
                  onClick={onDownloadCSV || (() => {})}
                  disabled={isDownloadingCSV}
                  loading={isDownloadingCSV}
                  style={{ minWidth: "150px" }}
                />
                <ButtonComp
                  btnText={isDownloadingPDF ? "Downloading..." : "Download PDF"}
                  btnClassName={`py-2 px-4 px-lg-5 fw-semibold bg-primary1 border-0 text-white rounded ${
                    isDownloadingPDF ? "opacity-75" : ""
                  }`}
                  containerClassName="w-auto"
                  onClick={onDownloadPDF || (() => {})}
                  disabled={isDownloadingPDF}
                  loading={isDownloadingPDF}
                  style={{ minWidth: "150px" }}
                />
              </div>
            </div>
          </CardComp>
        </>
      )}
      {tableData.length > 0 && pagination && (
        <div className="mt-4">
          <TablePagination
            {...pagination}
            currentPage={
              pagination?.currentPage || pagination?.page || pageNumber || 1
            }
            count={tableData.length} // Pass actual number of items on current page
            handlePageChange={onPageChange}
          />
        </div>
      )}
    </section>
  );
};

export default StaffMemberTable;
